import {investigation} from '../../../rest/investigations'
import {muteFields} from '../Tests/Tests.rest'

export const problemOccurrenceFields = `id,additionalData,newFailure,currentlyInvestigated,currentlyMuted,${muteFields},type,logAnchor,details,build(id,buildTypeId),problem(id,description,mutes(${muteFields}),investigations(${investigation}))`
export const problemOccurrencesTreeFields = `node(type,name,parentId,id,count,newFailedCount,childrenCount),leaf(id,nodeId,problemOccurrences(problemOccurrence(${problemOccurrenceFields})))`
